import { atomWithReset } from 'jotai/utils'

export const callDataAtom = atomWithReset({
  loading: false,
  disabled: false,
  phone: '',
  callLine: null,
  // coolPhone: undefined, // 智联外呼实例
});

export const callStateAtom = atomWithReset({
  isSeat: false,
  brandList: [],
  zitongId: '',
  zitongLine: null,
  zitongLines: [],
  zitongCallReturn: false,
});

export const callListAtom = atomWithReset({
  userInfo: {},
  userInfoLoading: false,
  reload: false,
});